import moment from "moment-jalali";

export const toDateString = (date, format = "jYYYY/jMM/jDD HH:mm:ss") => {
  if (!date) {
    return "";
  }
  return moment(date).format(format);
};

export const jalaliMonth = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];
